import React, { useState, useEffect, useContext } from 'react';
import { Box, Grid, Paper, Typography, TextField, Checkbox, FormControl, Radio, RadioGroup, CircularProgress, FormControlLabel, Table, TableHead, TableRow, TableCell, TableBody, Autocomplete, Chip } from '@mui/material';
import ApiService from "../../functions/apiService";
import { useSnackbar } from "notistack";
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import AuthContext from '../../context/AuthContext';

const Availability = () => {
  const { permission, pages } = useContext(AuthContext);
  const [availableData, setAvailableData] = useState([])
  const [availableDataNew, setAvailableDataNew] = useState([])
  const [availabilityChanges, setAvailabilityChanges] = useState({});
  const [selection, setSelection] = useState({});
  const displayFlag = pages.includes("AVAILABILITY_DISPLAY_UNAVAILABLE")


  const loadHoursData = () => {
    ApiService.get('/getEmployeeAvailability')
      .then(({ data }) => {
        if (displayFlag) {
          setAvailableDataNew(data?.data)
        }
        else {
          setAvailableData(data?.data)
        }
      })
      .catch(() => {
        console.error('error')
      })
  }

  useEffect(() => {
    loadHoursData()
  }, [])

  const handleToggle = (date, shiftCode) => {
    setAvailabilityChanges(prev => {
      const existing = prev[date]?.[shiftCode];
      const original = availableData[date][shiftCode === 2 ? 'Day' : 'Night'].is_available;
      const newVal = !(existing !== undefined ? existing === 'AVAILABLE' : original);

      return {
        ...prev,
        [date]: {
          ...prev[date],
          [shiftCode]: newVal ? 'AVAILABLE' : 'UNAVAILABLE',
        },
      };
    });
  };

  const getChecked = (date, shiftCode, original) => {
    const changed = availabilityChanges[date]?.[shiftCode];
    if (changed) return changed === 'AVAILABLE';
    return original;
  };

  useEffect(() => {
    const initialSelection = {};
    Object.entries(availableDataNew).forEach(([date, shiftObj]) => {
      const shift = shiftObj[24];
      if (shift?.is_available) initialSelection[date] = 'AVAILABLE';
      else if (shift?.is_unavailable) initialSelection[date] = 'UNAVAILABLE';
    });
    setSelection(initialSelection);
  }, [availableDataNew]);

  const handleSelect = (date, value) => {
    setSelection((prev) => ({
      ...prev,
      [date]: value,
    }));
  };

  const updateAvailability = () => {

    let payload;

    if (displayFlag) {
      const shiftCode = "1";
      payload = {
        availability: Object.fromEntries(
          Object.entries(selection).map(([date, status]) => [
            date,
            { [shiftCode]: status }
          ])
        )
      };
    } else {
      payload = { availability: availabilityChanges };
    }

    ApiService.post('/updateAvailability', payload)
      .then((data) => {
        toast.success(data?.message || 'Avalability updated');
        if (!displayFlag) {
          setAvailabilityChanges({});
        }
        loadHoursData();
      })
      .catch(({ data }) => {
        console.error('err', data);
      })
  };

  const hasAvailabilityChanges = Object.keys(availabilityChanges).some(date => {
    const dayChanges = availabilityChanges[date];
    return dayChanges && Object.keys(dayChanges).length > 0;
  });

  return (
    <>
      <Paper className="p-4" style={{ marginTop: "1rem" }}>
        <div className='mb-2'>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={10.5}>
              <Typography variant="h5">Availability</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={1.5}>
              <Typography variant="h5">
                {displayFlag ? (
                  <ButtonTheme type='submit' variant="filled" color='primary'
                    className='px-5' onClick={updateAvailability} disabled={Object.keys(selection).length === 0}>
                    Save
                  </ButtonTheme>
                ) : (
                  <ButtonTheme type='submit' variant="filled" color='primary'
                    className='px-5' onClick={updateAvailability} disabled={!hasAvailabilityChanges}>
                    Save
                  </ButtonTheme>
                )}
              </Typography>
            </Grid>
          </Grid>
        </div>
        <Box>

          {displayFlag ?
            (
              <Table>
                <TableHead sx={{ backgroundColor: "#F4F4F4" }}>
                  <TableRow>
                    <TableCell className="px-1">Date</TableCell>
                    <TableCell className="px-1">Duration</TableCell>
                    <TableCell className="px-1">Available</TableCell>
                    <TableCell className="px-1">Unavailable</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {availableDataNew &&
                    Object.keys(availableDataNew).map((dateStr) => {
                      const isDisabled = moment(dateStr).isSameOrBefore(moment(), 'day');

                      return (
                        <TableRow key={dateStr}>
                          <TableCell className="px-1" style={{ fontSize: 14 }}>
                            {moment(dateStr).format('MM/DD/YYYY, ddd')}
                          </TableCell>

                          <TableCell>
                            <Chip
                              label="24"
                              sx={{
                                backgroundColor: 'rgba(255, 165, 0, 0.26)',
                                border: '1px solid rgba(255, 165, 0, 0.28)',
                                color: '#000000',
                                fontSize: '14px',
                                fontWeight: 400,
                                padding: '2px 16px',
                                borderRadius: '25px',
                              }}
                            />
                          </TableCell>

                          <TableCell className="px-1">
                            <FormControlLabel
                              control={
                                <Radio
                                  checked={selection[dateStr] === 'AVAILABLE'}
                                  onChange={() => handleSelect(dateStr, 'AVAILABLE')}
                                  value="AVAILABLE"
                                  disabled={isDisabled}
                                />
                              }
                              label="Available"
                            />
                          </TableCell>

                          <TableCell className="px-1">
                            <FormControlLabel
                              control={
                                <Radio
                                  checked={selection[dateStr] === 'UNAVAILABLE'}
                                  onChange={() => handleSelect(dateStr, 'UNAVAILABLE')}
                                  value="UNAVAILABLE"
                                  disabled={isDisabled}
                                />
                              }
                              label="Unavailable"
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>

              // <Box
              //   sx={{
              //     maxWidth: "93vw",
              //     overflowX: "auto",
              //     background: "#FFF",
              //   }}
              // >
              //   <Grid container spacing={2} className="mt-2 mb-3">
              //     {availableDataNew && Object.keys(availableDataNew).map((dateStr) => (
              //       <Grid item xs={12} sm={6} md={4} key={dateStr}>
              //         <Box
              //           sx={{
              //             padding: '16px',
              //             backgroundColor: '#ffffff',
              //             borderRadius: '12px',
              //             border: '1px solid #EBECF0',
              //             boxShadow: `
              //               0px 3.26px 9.79px rgba(31, 64, 148, 0.02),
              //               0px 6.53px 7.18px rgba(22, 38, 61, 0.06),
              //               0px 1.96px 3.92px rgba(4, 43, 141, 0.03)
              //             `
              //           }}
              //         >
              //           <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#000000', mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              //             <div>
              //               Date: <span style={{ fontWeight: 400 }}>{moment(dateStr).format('MM/DD/YYYY, ddd')}</span>
              //             </div>
              //             <Chip
              //               label="24"
              //               sx={{
              //                 backgroundColor: 'rgba(255, 165, 0, 0.26)',
              //                 border: '1px solid rgba(255, 165, 0, 0.28)',
              //                 color: '#000000',
              //                 fontSize: '14px',
              //                 fontWeight: 400,
              //                 height: '24px',
              //                 borderRadius: '25px',
              //               }}
              //             />
              //           </Typography>

              //           <FormControl component="fieldset">
              //             <RadioGroup row name={`availability-${dateStr}`} value={selection[dateStr] || ''}>
              //               <FormControlLabel
              //                 value="AVAILABLE"
              //                 control={
              //                   <Radio
              //                     onChange={() => handleSelect(dateStr, 'AVAILABLE')}
              //                     checked={selection[dateStr] === 'AVAILABLE'}
              //                   />
              //                 }
              //                 label="Available"
              //               />
              //               <FormControlLabel
              //                 value="UNAVAILABLE"
              //                 control={
              //                   <Radio
              //                     onChange={() => handleSelect(dateStr, 'UNAVAILABLE')}
              //                     checked={selection[dateStr] === 'UNAVAILABLE'}
              //                   />
              //                 }
              //                 label="Unavailable"
              //               />
              //             </RadioGroup>
              //           </FormControl>
              //         </Box>
              //       </Grid>
              //     ))}
              //   </Grid>
              // </Box>

            )
            :
            (
              <Table>
                <TableHead sx={{ backgroundColor: "#F4F4F4" }}>
                  <TableRow>
                    <TableCell className="px-1">Date</TableCell>
                    <TableCell className="px-1">Day Shift</TableCell>
                    <TableCell className="px-1">Night Shift</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {availableData && Object.keys(availableData).map((dateStr) => {
                    const shiftData = availableData[dateStr];
                    const dayShift = shiftData.Day;
                    const nightShift = shiftData.Night;

                    const isDisabled = moment(dateStr).isSameOrBefore(moment(), 'day');

                    return (
                      <TableRow key={dateStr}>
                        <TableCell className="px-1" style={{ fontSize: 14, color: '#000000' }}>
                          {moment(dateStr).format('MM/DD/YYYY, ddd')}
                        </TableCell>

                        <TableCell className="px-1">
                          <Chip
                            label="Day"
                            sx={{
                              backgroundColor: 'rgba(255, 165, 0, 0.26)',
                              border: '1px solid rgba(255, 165, 0, 0.28)',
                              color: '#000000',
                              fontSize: '14px',
                              fontWeight: 400,
                              padding: '2px 16px',
                              borderRadius: '25px',
                              marginRight: '40px'
                            }}
                          />
                          <Checkbox
                            checked={getChecked(dateStr, 2, dayShift.is_available)}
                            onChange={() => handleToggle(dateStr, 2)}
                            disabled={isDisabled}
                          />
                          <span>Available</span>
                        </TableCell>

                        <TableCell className="px-1">
                          <Chip
                            label="Night"
                            sx={{
                              backgroundColor: 'rgba(52, 152, 219, 0.16)',
                              border: '1px solid rgba(52, 152, 219, 0.2)',
                              color: '#000000',
                              fontSize: '14px',
                              fontWeight: 400,
                              padding: '2px 16px',
                              borderRadius: '25px',
                              marginRight: '40px'
                            }}
                          />
                          <Checkbox
                            checked={getChecked(dateStr, 3, nightShift.is_available)}
                            onChange={() => handleToggle(dateStr, 3)}
                            disabled={isDisabled}
                          />
                          <span>Available</span>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>

              // <Box
              //   sx={{
              //     maxWidth: "93vw",
              //     overflowX: "auto",
              //     background: "#FFF",
              //   }}
              // >
              //   <Grid container spacing={2} className="mt-2 mb-3">
              //     {availableData && Object.keys(availableData).map((dateStr) => {
              //       const shiftData = availableData[dateStr];
              //       const dayShift = shiftData.Day;
              //       const nightShift = shiftData.Night;

              //       return (
              //         <Grid item xs={12} sm={6} md={4} key={dateStr}>
              //           <Box
              //             sx={{
              //               padding: '16px',
              //               backgroundColor: '#ffffff',
              //               borderRadius: '12px',
              //               border: '1px solid #EBECF0',
              //               boxShadow: `
              //                 0px 3.26px 9.79px rgba(31, 64, 148, 0.02),
              //                 0px 6.53px 7.18px rgba(22, 38, 61, 0.06),
              //                 0px 1.96px 3.92px rgba(4, 43, 141, 0.03)
              //               `
              //             }}
              //           >

              //             <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#000000', mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              //               <div>
              //                 Date: <span style={{ fontWeight: 400 }}>{moment(dateStr).format('MM/DD/YYYY, ddd')}</span>
              //               </div>
              //               <Chip
              //                 label="Availability"
              //                 sx={{
              //                   backgroundColor: 'rgba(255, 165, 0, 0.26)',
              //                   border: '1px solid rgba(255, 165, 0, 0.28)',
              //                   color: '#000000',
              //                   fontSize: '14px',
              //                   fontWeight: 400,
              //                   height: '24px',
              //                   borderRadius: '25px',
              //                 }}
              //               />
              //             </Typography>

              //             <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              //               <Box display="flex" alignItems="center">
              //                 <Checkbox
              //                   checked={getChecked(dateStr, 2, dayShift.is_available)}
              //                   onChange={() => handleToggle(dateStr, 2)}
              //                 />
              //                 <span style={{ fontSize: 14 }}>Day</span>
              //               </Box>

              //               <Box display="flex" alignItems="center">
              //                 <Checkbox
              //                   checked={getChecked(dateStr, 3, nightShift.is_available)}
              //                   onChange={() => handleToggle(dateStr, 3)}
              //                 />
              //                 <span style={{ fontSize: 14 }}>Night</span>
              //               </Box>
              //             </div>
              //           </Box>
              //         </Grid>
              //       );
              //     })}
              //   </Grid>
              // </Box>

            )
          }

          {displayFlag ? (
            <ButtonTheme type='submit' variant="filled" color='primary'
              className='px-5 mt-4' onClick={updateAvailability} disabled={Object.keys(selection).length === 0}>
              Save
            </ButtonTheme>
          ) : (
            <ButtonTheme type='submit' variant="filled" color='primary'
              className='px-5 mt-4' onClick={updateAvailability} disabled={!hasAvailabilityChanges}>
              Save
            </ButtonTheme>
          )}

        </Box>
      </Paper >
    </>
  )
}

export default Availability;
